export default {
  'ATTACHMENTTYPE' (state) {
    return state.attachmentType
  },
  'ATTACHMENTTYPES' (state) {
    return state.attachmentTypes
  }
}
